import React from 'react'
import {
    Box,
    Typography,
} from "@mui/material";

export default function Part1() {
    return (
        <React.Fragment>
            <Box my={1}>
                <Typography className="text-bold">1.บทนำ</Typography>
                <Typography className="text-normal">บริษัท ยูนิเวิร์ส ออฟ อีโวลูชั่น 4289 จำกัด (“บริษัท”) เป็นผู้ให้บริการค้นหางาน และ/หรือ สมัครงานสำหรับผู้หางาน และเป็นแหล่งค้นประวัติ และ/หรือ รับสมัครงานสำหรับผู้ประกอบการ โดยผ่านทางเว็บไซต์ และ/หรือ แอปพลิเคชันต่าง ๆ รวมถึงผลิตภัณฑ์ต่าง ๆ ที่อาจมีขึ้นในอนาคตของ บริษัท ยูนิเวิร์ส ออฟ อีโวลูชั่น 4289 จำกัดบริษัทให้ความสำคัญสูงสุดกับความเป็นส่วนตัวและความปลอดภัยของข้อมูลส่วนบุคคล รวมถึงการรักษาข้อมูลส่วนบุคคลของผู้ใช้บริการไว้เป็นความลับ ดังนั้น นโยบายความเป็นส่วนตัวฉบับนี้มีขึ้นเพื่อชี้แจงรายละเอียดเกี่ยวกับข้อมูลส่วนบุคคลที่จะทำการเก็บรวบรวม วิธีการจัดการเกี่ยวกับข้อมูลส่วนบุคคลว่ามีการดำเนินการและวัตถุประสงค์อย่างไร ตลอดจนวิธีการติดต่อขอลบหรือเปลี่ยนแปลงข้อมูลส่วนบุคคล นโยบายความเป็นส่วนตัวฉบับนี้มีผลใช้บังคับกับผู้ใช้บริการทุกท่าน ยกเว้นในกรณีที่ระบุไว้เป็นอย่างอื่นในนโยบายความเป็นส่วนตัว กรุณาอ่านนโยบายความเป็นส่วนตัวของบริษัทอย่างรอบคอบเพื่อให้ท่านเข้าใจถึงหลักการและวิธีการใช้ข้อมูลดังกล่าว</Typography>
            </Box>
        </React.Fragment>
    )
}
